var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, TransformValidateDateTime, TransformValidateModel, transformer,
//transformer,
 } from "@musicaudienceexchange/toccata";
import { Customizations, FormField } from "./customizations";
import { PaymentTypes } from "../functions";
import { PageProperties, PageViewProps } from "./templates";
export * from "./templates";
export * as auction from "./auction";
export * as branding from "./branding";
export * as utils from "./utils";
export const PhoneTypes = [
    "unknown",
    "mobile",
    "voip",
    "landline",
    "invalid",
];
/**
 * @path {/nextsong_groups/<groupId>}
 */
export class Group extends Model {
}
__decorate([
    validator.IsString()
], Group.prototype, "name", void 0);
__decorate([
    validator.IsString()
], Group.prototype, "image", void 0);
__decorate([
    validator.IsString()
], Group.prototype, "stripeConnectId", void 0);
__decorate([
    validator.IsString({ each: true })
], Group.prototype, "memberUids", void 0);
/**
 * @path {/nextsong_songs/<songId>}
 */
export class Song extends Model {
}
__decorate([
    validator.IsString()
], Song.prototype, "title", void 0);
__decorate([
    validator.IsString()
], Song.prototype, "artist", void 0);
export class TabIcon extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], TabIcon.prototype, "lightPath", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], TabIcon.prototype, "darkPath", void 0);
export class CustomTab extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], CustomTab.prototype, "enabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CustomTab.prototype, "tabLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CustomTab.prototype, "tabHtml", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(TabIcon)
], CustomTab.prototype, "tabIcon", void 0);
__decorate([
    TransformValidateModel(PageProperties),
    validator.IsOptional()
], CustomTab.prototype, "page", void 0);
export class Auction extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Auction.prototype, "enabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Auction.prototype, "tabLabel", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Auction.prototype, "tabHtml", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(TabIcon)
], Auction.prototype, "tabIcon", void 0);
export class Sweeps extends Model {
}
Sweeps.defaults = {
    numberOfWinners: 3,
    limitToVenue: false,
};
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Sweeps.prototype, "enabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Sweeps.prototype, "numberOfWinners", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Sweeps.prototype, "limitToVenue", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateDateTime()
], Sweeps.prototype, "endedAt", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsArray()
], Sweeps.prototype, "entryWinnerUids", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsArray()
], Sweeps.prototype, "entryWinnerHashes", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsArray()
], Sweeps.prototype, "entryIgnoreUids", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Sweeps.prototype, "proximityLimitInMiles", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sweeps.prototype, "winnerMessage", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Sweeps.prototype, "winnerQrLink", void 0);
export class CheckIn extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "tab", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "actionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "modalTitle", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "modalDescription", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "modalActionText", void 0);
__decorate([
    TransformValidateModel(FormField, { each: true }),
    validator.IsOptional()
], CheckIn.prototype, "form", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "formTemplateId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "preCheckInHtml", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], CheckIn.prototype, "postCheckInHtml", void 0);
__decorate([
    TransformValidateModel(PageViewProps),
    validator.IsOptional()
], CheckIn.prototype, "pages", void 0);
export class Coordinates extends Model {
}
__decorate([
    validator.IsLatitude()
], Coordinates.prototype, "latitude", void 0);
__decorate([
    validator.IsLongitude()
], Coordinates.prototype, "longitude", void 0);
export class Encore extends Model {
}
Encore.defaults = {
    minVoteAmount: 500,
};
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Encore.prototype, "enabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Encore.prototype, "endOffset", void 0);
__decorate([
    validator.IsNumber()
], Encore.prototype, "minVoteAmount", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Encore.prototype, "description2", void 0);
export class Charity extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Charity.prototype, "enabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "tab", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "title", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "description", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "actionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "preDonateMessage", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "postDonateMessage", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Charity.prototype, "donationsTotalMessage", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Charity.prototype, "showDonationsTotal", void 0);
export class FreeRequest extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], FreeRequest.prototype, "modalDescription", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], FreeRequest.prototype, "modalActionText", void 0);
__decorate([
    TransformValidateModel(FormField, { each: true }),
    validator.IsOptional()
], FreeRequest.prototype, "fields", void 0);
export const EventTypes = [
    "vote",
    "donate",
    "sponsor",
    "encore",
    "checkIn",
    "freeRequest",
    "auction",
];
export const EventStatuses = ["published", "unpublished", "deleted"];
const SocialColorNames = ["black", "white", "default"];
export class Bio extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Bio.prototype, "enabled", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "bioImage", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "artistBio", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString({ each: true })
], Bio.prototype, "shareUrls", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsIn(SocialColorNames),
    validator.IsString()
], Bio.prototype, "shareColor", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "actionDescription", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "actionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "modalTitle", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "modalDescription", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "modalActionText", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Bio.prototype, "tabName", void 0);
export const I18nCodes = ["en", "es"];
export class I18n extends Model {
}
__decorate([
    validator.IsOptional(),
    validator.IsString()
], I18n.prototype, "englishVersionId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], I18n.prototype, "spanishVersionId", void 0);
export class MaxCampaign extends Model {
}
__decorate([
    validator.IsNumber()
], MaxCampaign.prototype, "id", void 0);
__decorate([
    validator.IsString()
], MaxCampaign.prototype, "name", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], MaxCampaign.prototype, "imageUrl", void 0);
export const EntriesExportStatuses = [
    "available",
    "generating",
    "failed",
];
/**
 * @path {/nextsong_events/<eventId>}
 */
export class Event extends Model {
}
Event.defaults = {
    repeatCost: 10000,
    type: "vote",
    endedAt: null,
    autoEndAfter: 8,
    maxSponsorshipCount: 3,
    status: "published",
    checkIn: CheckIn.load({}),
};
__decorate([
    validator.IsString()
], Event.prototype, "groupId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Event.prototype, "brandingId", void 0);
__decorate([
    validator.IsString({ each: true })
], Event.prototype, "memberUids", void 0);
__decorate([
    validator.IsNotEmpty(),
    validator.IsString()
], Event.prototype, "artistName", void 0);
__decorate([
    validator.IsNotEmpty(),
    validator.IsString()
], Event.prototype, "image", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Event.prototype, "imageBanner", void 0);
__decorate([
    validator.IsNotEmpty(),
    validator.IsString()
], Event.prototype, "venue", void 0);
__decorate([
    validator.IsNotEmpty(),
    validator.IsString()
], Event.prototype, "address", void 0);
__decorate([
    TransformValidateModel(Coordinates)
], Event.prototype, "coordinates", void 0);
__decorate([
    TransformValidateDateTime()
], Event.prototype, "startsAt", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Event.prototype, "timeZoneName", void 0);
__decorate([
    TransformValidateDateTime(),
    validator.IsOptional()
], Event.prototype, "endedAt", void 0);
__decorate([
    TransformValidateDateTime(),
    validator.IsOptional()
], Event.prototype, "deletedAt", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsPositive()
], Event.prototype, "autoEndAfter", void 0);
__decorate([
    validator.IsNumber()
], Event.prototype, "repeatCost", void 0);
__decorate([
    validator.IsString(),
    validator.IsIn(EventTypes)
], Event.prototype, "type", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], Event.prototype, "minVoteAmount", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsPositive(),
    validator.IsOptional()
], Event.prototype, "maxSponsorshipCount", void 0);
__decorate([
    validator.IsArray(),
    validator.IsOptional()
], Event.prototype, "minSponsorAmount", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Encore)
], Event.prototype, "encore", void 0);
__decorate([
    TransformValidateModel(CheckIn),
    validator.ValidateIf((o) => o.type === "checkIn"),
    transformer.Transform(({ obj, value }) => obj.type === "checkIn" ? value : undefined)
], Event.prototype, "checkIn", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(CustomTab)
], Event.prototype, "customTab", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Customizations)
], Event.prototype, "customizations", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Event.prototype, "checkboxLabel", void 0);
__decorate([
    validator.IsBoolean(),
    validator.IsOptional()
], Event.prototype, "registrationRequired", void 0);
__decorate([
    validator.IsIn(EventStatuses)
], Event.prototype, "status", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Sweeps)
], Event.prototype, "sweeps", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Charity)
], Event.prototype, "charity", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Auction)
], Event.prototype, "auction", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Event.prototype, "playlistSongsCount", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(FreeRequest)
], Event.prototype, "freeRequest", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Event.prototype, "emailTemplateId", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Bio)
], Event.prototype, "bio", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(I18n)
], Event.prototype, "i18n", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(MaxCampaign)
], Event.prototype, "maxCampaign", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsIn(EntriesExportStatuses)
], Event.prototype, "entriesExportStatus", void 0);
__decorate([
    validator.IsObject(),
    validator.IsOptional()
], Event.prototype, "geocode", void 0);
export class Sponsorship extends Model {
}
__decorate([
    validator.IsString()
], Sponsorship.prototype, "displayName", void 0);
__decorate([
    validator.IsString()
], Sponsorship.prototype, "dedicationName", void 0);
__decorate([
    validator.IsString()
], Sponsorship.prototype, "dedicationMessage", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Sponsorship.prototype, "occasion", void 0);
export const RequestTypes = [...EventTypes, "encore", "checkIn"];
/**
 * @path {/nextsong_events/<eventId>/requests/<requestId>}
 */
export class Request extends Model {
}
__decorate([
    validator.IsNumber()
], Request.prototype, "amount", void 0);
__decorate([
    validator.IsString()
], Request.prototype, "displayName", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional(),
    validator.ValidateIf((o) => o.type === "vote" || o.type === "sponsor")
], Request.prototype, "songId", void 0);
__decorate([
    TransformValidateDateTime()
], Request.prototype, "createdAt", void 0);
__decorate([
    validator.IsString(),
    validator.IsIn(RequestTypes)
], Request.prototype, "type", void 0);
__decorate([
    validator.IsString()
], Request.prototype, "uid", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Request.prototype, "status", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsBoolean()
], Request.prototype, "read", void 0);
__decorate([
    validator.IsOptional(),
    TransformValidateModel(Sponsorship)
], Request.prototype, "sponsorship", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Request.prototype, "location", void 0);
/**
 * @path {/nextsong_events/<eventId>/playlist/<songId>}
 */
export class EventSong extends Model {
}
EventSong.defaults = {
    playedAt: [],
};
__decorate([
    validator.IsString()
], EventSong.prototype, "title", void 0);
__decorate([
    validator.IsString()
], EventSong.prototype, "artist", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], EventSong.prototype, "priority", void 0);
__decorate([
    TransformValidateDateTime({ each: true })
], EventSong.prototype, "playedAt", void 0);
__decorate([
    validator.IsBoolean(),
    validator.IsOptional()
], EventSong.prototype, "encore", void 0);
__decorate([
    validator.IsBoolean(),
    validator.IsOptional()
], EventSong.prototype, "declined", void 0);
export class PaymentMethod extends Model {
}
__decorate([
    validator.IsString()
], PaymentMethod.prototype, "id", void 0);
__decorate([
    validator.IsString()
], PaymentMethod.prototype, "brand", void 0);
__decorate([
    validator.IsString()
], PaymentMethod.prototype, "last4", void 0);
__decorate([
    validator.IsString()
], PaymentMethod.prototype, "expMonth", void 0);
__decorate([
    validator.IsString()
], PaymentMethod.prototype, "expYear", void 0);
export class PaymentSetup extends Model {
}
__decorate([
    validator.IsString()
], PaymentSetup.prototype, "id", void 0);
__decorate([
    TransformValidateModel(PaymentMethod)
], PaymentSetup.prototype, "paymentMethod", void 0);
/**
 * @path {/nextsong_users/<uid>}
 */
export class User extends Model {
}
User.defaults = {
    paymentMethods: [],
};
__decorate([
    validator.IsString(),
    validator.IsOptional()
], User.prototype, "displayName", void 0);
__decorate([
    validator.IsEmail(),
    validator.IsOptional()
], User.prototype, "email", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], User.prototype, "name", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], User.prototype, "phone", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], User.prototype, "zipcode", void 0);
__decorate([
    TransformValidateModel(PaymentMethod, { each: true })
], User.prototype, "paymentMethods", void 0);
__decorate([
    TransformValidateModel(PaymentSetup),
    validator.IsOptional()
], User.prototype, "paymentSetup", void 0);
/**
 * All songs that artist has entered into the system (not event-specific)
 */
export class GroupCatalogSong extends Model {
}
/**
 * Collection of songs from the artist's catalog (not event-specific)
 *  - Female Leads
 *  - 80s
 *  - Funk
 */
export class GroupPlaylist extends Model {
}
export class Payment extends Model {
}
__decorate([
    validator.IsNumber(),
    validator.Min(0),
    validator.IsDivisibleBy(100)
], Payment.prototype, "amount", void 0);
__decorate([
    validator.IsString(),
    validator.IsIn(PaymentTypes)
], Payment.prototype, "type", void 0);
__decorate([
    validator.IsString()
], Payment.prototype, "eventId", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional(),
    validator.ValidateIf((o) => o.type === "vote" || o.type === "sponsor" || o.type === "encore")
], Payment.prototype, "songId", void 0);
__decorate([
    validator.IsEmail()
], Payment.prototype, "email", void 0);
__decorate([
    validator.IsString(),
    validator.MinLength(3)
], Payment.prototype, "name", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "phone", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "location", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "zipcode", void 0);
__decorate([
    validator.ValidateIf((o) => o.type === "sponsor"),
    validator.IsOptional(),
    TransformValidateModel(Sponsorship)
], Payment.prototype, "sponsorship", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsObject()
], Payment.prototype, "extraFields", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], Payment.prototype, "displayName", void 0);
__decorate([
    validator.IsBoolean(),
    validator.IsOptional()
], Payment.prototype, "read", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsObject()
    // @TransformValidateModel(Coordinates)
], Payment.prototype, "coordinates", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsNumber()
], Payment.prototype, "distance", void 0);
__decorate([
    validator.IsString()
], Payment.prototype, "uid", void 0);
__decorate([
    validator.IsString()
], Payment.prototype, "status", void 0);
__decorate([
    validator.IsString()
], Payment.prototype, "intentId", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsString()
], Payment.prototype, "ipaddress", void 0);
__decorate([
    TransformValidateDateTime()
], Payment.prototype, "createdAt", void 0);
__decorate([
    TransformValidateDateTime()
], Payment.prototype, "updatedAt", void 0);
/**
 * Path: /nextsong_events/{eventId}/entries/{entryId}
 */
export class SweepsEntry extends Model {
}
SweepsEntry.defaults = {
    phoneType: "unknown",
    inVenue: false,
    seed: 0,
};
__decorate([
    TransformValidateModel(Coordinates),
    validator.IsOptional()
], SweepsEntry.prototype, "coordinates", void 0);
__decorate([
    validator.IsNumber(),
    validator.IsOptional()
], SweepsEntry.prototype, "minDistance", void 0);
__decorate([
    validator.IsBoolean()
], SweepsEntry.prototype, "inVenue", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], SweepsEntry.prototype, "phone", void 0);
__decorate([
    validator.IsString(),
    validator.IsIn(PhoneTypes)
], SweepsEntry.prototype, "phoneType", void 0);
__decorate([
    validator.IsString()
], SweepsEntry.prototype, "email", void 0);
__decorate([
    validator.IsString()
], SweepsEntry.prototype, "name", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], SweepsEntry.prototype, "zipcode", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], SweepsEntry.prototype, "location", void 0);
__decorate([
    validator.IsOptional(),
    validator.IsObject()
], SweepsEntry.prototype, "extraFields", void 0);
__decorate([
    validator.IsString()
], SweepsEntry.prototype, "uid", void 0);
__decorate([
    validator.IsNumber()
], SweepsEntry.prototype, "seed", void 0);
//# sourceMappingURL=index.js.map